import { render, staticRenderFns } from "./BubbleModal.vue?vue&type=template&id=50591534&scoped=true"
import script from "./BubbleModal.vue?vue&type=script&lang=js"
export * from "./BubbleModal.vue?vue&type=script&lang=js"
import style0 from "./BubbleModal.vue?vue&type=style&index=0&id=50591534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50591534",
  null
  
)

export default component.exports